module.exports = __webpack_public_path__ + "img/dropdown.25b84356.svg";